import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=1e8f2a38"
import script from "./CustomSelect.vue?vue&type=script&lang=ts"
export * from "./CustomSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports